import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useOnPageLoad } from "./useOnPageLoad";

export const useScrollToAnchor = (id: string) => {
  const location = useLocation();
  const [ref, setRef] = useState({} as HTMLDivElement);
  const [isLoaded, setIsLoaded] = useState(false);
  const handleRef = (newRef: HTMLDivElement) => setRef(newRef);

  useOnPageLoad(() => setIsLoaded(true));

  useEffect(() => {
    if (!isLoaded) return;
    if (location.hash !== `#${id}`) return;
    if (!ref || !Object.keys(ref).length) return;

    ref.scrollIntoView({ block: "center", behavior: "smooth" });
  }, [id, location.hash, location.state, ref, isLoaded]);

  return {
    id,
    ref: handleRef,
  };
};
